import React, { useState } from "react";

const questions = [
  {
    id: 1,
    text: "1. Trong ngữ cảnh công sở, 'Tô Cơm' (hoặc 'Cheese') đại diện cho điều gì?",
    options: {
      A: "Chỉ đơn thuần là mức lương cuối tháng.",
      B: "Bất cứ thứ gì bạn coi trọng: sự ổn định, phần mềm quen thuộc, một dự án ngon ăn, hay lương thưởng.",
      C: "Bữa trưa miễn phí ở căn tin công ty."
    },
    correct: "B"
  },
  {
    id: 2,
    text: "2. Nhân vật nào trong câu chuyện luôn ngửi thấy sự thay đổi từ trước khi nó trở thành rắc rối lớn?",
    options: {
      A: "Sniff (Nhạy bén)",
      B: "Scurry (Hành động)",
      C: "Hem (Bảo thủ)"
    },
    correct: "A"
  },
  {
    id: 3,
    text: "3. Khi phát hiện 'tô cơm' đã biến mất, nhân vật Scurry (Hành động) làm gì đầu tiên?",
    options: {
      A: "Triệu tập một cuộc họp để thảo luận về cảm xúc của mọi người.",
      B: "Ngay lập tức chạy xộc vào mê cung để đi tìm nguồn thức ăn mới.",
      C: "Gửi email khiếu nại lên ban giám đốc."
    },
    correct: "B"
  },
  {
    id: 4,
    text: "4. Tại sao nhân vật Hem (Bảo thủ) lại nhất quyết không chịu đi tìm 'cơm' mới?",
    options: {
      A: "Vì anh ta đang bận làm việc khác.",
      B: "Vì anh ta cho rằng mình 'có quyền' được hưởng tô cơm cũ, và sợ hãi những rủi ro ở bên ngoài.",
      C: "Vì anh ta thực ra không hề đói."
    },
    correct: "B"
  },
  {
    id: 5,
    text: "5. Bước ngoặt thức tỉnh của nhân vật Haw diễn ra khi nào?",
    options: {
      A: "Khi ai đó mang tô cơm mới dâng tận miệng anh ta.",
      B: "Khi sếp ép anh ta phải thay đổi bằng KPIs.",
      C: "Khi anh ta nhận ra nỗi sợ hãi đang giam cầm chính mình, và tự cười vào sự bướng bỉnh đó."
    },
    correct: "C"
  },
  {
    id: 6,
    text: "6. Mối nguy hiểm lớn nhất khi công ty đang trong giai đoạn chuyển giao/thay đổi là gì?",
    options: {
      A: "Làm sai một vài quy trình mới.",
      B: "Bám víu vào quá khứ và chờ đợi mọi thứ quay trở lại 'bình thường' như xưa.",
      C: "Hỏi quá nhiều câu hỏi để làm rõ vấn đề."
    },
    correct: "B"
  },
  {
    id: 7,
    text: "7. Câu nào sau đây đúng với nhân vật Haw (Thức tỉnh)?",
    options: {
      A: "Anh ta không bao giờ biết sợ là gì.",
      B: "Anh ta vẫn thấy sợ, nhưng quyết định hành động xuyên qua cả nỗi sợ hãi đó.",
      C: "Anh ta là người tìm ra tô cơm nhanh nhất."
    },
    correct: "B"
  },
  {
    id: 8,
    text: "8. Công ty áp dụng công cụ AI mới. Câu nói nào mang đậm chất 'Hem' (Bảo thủ) nhất?",
    options: {
      A: "Trời, cách cũ đang xài ngon chán! Máy móc sao bằng con người được, tôi không xài đâu.",
      B: "Để tôi mở tài khoản xài thử coi sao.",
      C: "Chắc phải đi học một khóa Prompt AI để bắt kịp xu hướng thôi."
    },
    correct: "A"
  },
  {
    id: 9,
    text: "9. Cách tốt nhất để vượt qua nỗi sợ hãi môi trường mới là gì?",
    options: {
      A: "Làm ngơ nó đi, chuyện tới đâu hay tới đó.",
      B: "Hình dung trước cảnh bản thân thích nghi thành công và gặt hái được những thành quả mới.",
      C: "Rủ đồng nghiệp đi nhậu và nói xấu công ty."
    },
    correct: "B"
  },
  {
    id: 10,
    text: "10. Tại sao quy tắc sống còn là phải 'Thường xuyên ngửi tô cơm của bạn'?",
    options: {
      A: "Để đảm bảo không ai trong công ty ăn trộm ý tưởng của bạn.",
      B: "Để sớm nhận ra những dấu hiệu thay đổi nhỏ gọn (sếp đổi ý, xu hướng đổi) trước khi quá muộn.",
      C: "Vì đó là quy định bắt buộc của phòng HR."
    },
    correct: "B"
  },
  {
    id: 11,
    text: "11. Cảm giác thường thấy nhất SAU KHI bạn chịu buông bỏ cái cũ và tiến vào cái mới là gì?",
    options: {
      A: "Mệt mỏi và hối hận.",
      B: "Nhẹ nhõm, tự do và tràn đầy năng lượng hơn bạn tưởng.",
      C: "Muốn quay lại ngay lập tức."
    },
    correct: "B"
  },
  {
    id: 12,
    text: "12. Trong một công ty, ai là người chịu trách nhiệm chính trong việc đảm bảo bạn có 'tô cơm' mới khi thị trường xoay trục?",
    options: {
      A: "Sếp tổng hoặc bộ phận Nhân Sự.",
      B: "Chính bản thân bạn, bằng cách liên tục học hỏi và thích ứng nhanh chóng.",
      C: "Phòng Marketing và Sales."
    },
    correct: "B"
  }
];

export default function RiceBowlKnowledge() {
  const [answers, setAnswers] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [score, setScore] = useState(0);

  const handleSelect = (questionId, optionKey) => {
    if (!isSubmitted) {
      setAnswers({ ...answers, [questionId]: optionKey });
    }
  };

  const calculateScore = () => {
    if (Object.keys(answers).length < questions.length) {
      alert("Chưa trả lời hết kìa người anh em! Làm cho trót rồi hãy chấm điểm.");
      return;
    }

    let currentScore = 0;
    questions.forEach((q) => {
      if (answers[q.id] === q.correct) currentScore++;
    });

    setScore(currentScore);
    setIsSubmitted(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px", fontFamily: "sans-serif" }}>
      <h1 style={{ textAlign: "center", color: "#333" }}>Bài Test Sinh Tồn Chốn Công Sở 🧠</h1>
      
      {!isSubmitted ? (
        <p style={{ textAlign: "center", color: "#666", marginBottom: "30px" }}>
          Làm nhanh 12 câu này để xem anh em đã 'thấm' được nghệ thuật bảo vệ tô cơm chưa nhé!
        </p>
      ) : (
        <div style={{ textAlign: "center", padding: "20px", borderRadius: "8px", backgroundColor: score >= 9 ? "#d4edda" : "#fff3cd", color: score >= 9 ? "#155724" : "#856404", marginBottom: "30px", border: `2px solid ${score >= 9 ? "#c3e6cb" : "#ffeeba"}` }}>
          <h2>Điểm của bạn: {score} / 12</h2>
          <p style={{ fontSize: "18px", fontWeight: "bold" }}>
            {score === 12 ? "Thánh sinh tồn! Ném bạn vào môi trường nào bạn cũng sống khỏe! 🏆" :
             score >= 8 ? "Khá lắm! Bạn đã sẵn sàng để đón nhận sóng gió công sở rồi! 🔥" :
             "Nguy hiểm quá nha! Bạn dễ bị đào thải lắm đó, mở lại Podcast nghe liền! 😅"}
          </p>
          <p style={{ fontSize: "14px" }}>Kéo xuống để soi xem mình sai ở đâu 👇</p>
        </div>
      )}

      <div>
        {questions.map((q) => (
          <div key={q.id} style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
            <p style={{ fontWeight: "bold", marginTop: "0" }}>{q.text}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {Object.entries(q.options).map(([key, text]) => {
                let labelStyle = { cursor: isSubmitted ? "default" : "pointer", display: "flex", alignItems: "flex-start", gap: "10px", padding: "8px", borderRadius: "5px" };
                
                if (isSubmitted) {
                  if (key === q.correct) {
                    labelStyle.backgroundColor = "#d4edda";
                    labelStyle.border = "1px solid #c3e6cb";
                  } else if (answers[q.id] === key && key !== q.correct) {
                    labelStyle.backgroundColor = "#f8d7da";
                    labelStyle.border = "1px solid #f5c6cb";
                  }
                }

                return (
                  <label key={key} style={labelStyle}>
                    <input
                      type="radio"
                      name={`knowledge-${q.id}`}
                      value={key}
                      checked={answers[q.id] === key}
                      onChange={() => handleSelect(q.id, key)}
                      disabled={isSubmitted}
                      style={{ width: "20px", height: "20px", marginTop: "3px" }}
                    />
                    <span style={{ lineHeight: "1.4" }}>{text}</span>
                  </label>
                );
              })}
            </div>
            {isSubmitted && answers[q.id] !== q.correct && (
              <p style={{ color: "#d9534f", fontSize: "14px", marginTop: "10px", fontWeight: "bold" }}>
                👉 Đáp án đúng là {q.correct} nha bạn ơi!
              </p>
            )}
          </div>
        ))}

        {!isSubmitted ? (
          <button 
            onClick={calculateScore} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Nộp Bài!
          </button>
        ) : (
          <button 
            onClick={() => { setIsSubmitted(false); setAnswers({}); setScore(0); window.scrollTo({ top: 0, behavior: "smooth" }); }} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#333", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Làm Lại Lần Nữa Cho Nhớ!
          </button>
        )}
      </div>
    </div>
  );
}